window.addEventListener("load", function () {
  var swiperNewlyArrivedProductsSlider = new Swiper(
    ".swiperNewlyArrivedProductsSlider",
    {
      effect: "coverflow",
      grabCursor: true,
      centeredSlides: true,
      slidesPerView: "auto",
      coverflowEffect: {
        rotate: 50,
        stretch: 0,
        depth: 100,
        modifier: 1,
        slideShadows: true,
      },
    }
  );
});
